import {empty} from '@convincely/utils/lib/strings.js';

const spaces = /\s/g;

export function generatePhoneLink(str) {
  return `tel:${String(str).split(spaces).join(empty)}`;
}
